import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist({
  key: "invoiceReportPersistedState", // storage key
  storage: localStorage, // or sessionStorage
});
const getFormattedCurrentDate = () => {
  const today = new Date();
  const day = today.getDate();
  const month = today.toLocaleString("en-US", { month: "long" });
  const year = today.getFullYear();
  const formattedDay = day < 10 ? `0${day}` : day;

  return `${month} ${formattedDay}, ${year}`;
};
const getFormattedDate = () => {
  const today = new Date();
  return today.toISOString().split("T")[0]; // Extracts YYYY-MM-DD from ISO format
};

export const invoicesLoadedState = atom({
  key: "invoicesLoadedState",
  default: false,
});

export const invoicesState = atom({
  key: "invoicesState",
  default: [],
});

export const invoiceTotalState = atom({
  key: "invoiceTotalState",
  default: 0,
});

export const invoiceGTotalState = atom({
  key: "invoiceGTotalState",
  default: 0,
});

export const invoiceDiscountState = atom({
  key: "invoiceDiscountState",
  default: 0,
});

export const invoiceDueState = atom({
  key: "invoiceDueState",
  default: 0,
});

export const submitStatusState = atom({
  key: "submitStatusState",
  default: false,
});

export const rowLoadingState = atom({
  key: "invoiceRowLoadingState",
  default: false,
});

export const formattedFromDateState = atom({
  key: "invoiceFormattedFromDateState",
  default: getFormattedCurrentDate(),
  effects_UNSTABLE: [persistAtom],
});

export const formattedToDateState = atom({
  key: "invoiceFormattedToDateState",
  default: getFormattedCurrentDate(),
  effects_UNSTABLE: [persistAtom],
});

export const fromDateState = atom({
  key: "invoiceFromDateState",
  default: getFormattedDate(),
  effects_UNSTABLE: [persistAtom],
});

export const toDateState = atom({
  key: "invoiceToDateState",
  default: getFormattedDate(),
  effects_UNSTABLE: [persistAtom],
});
